import {post} from './baseService';

export function submitUserMandatoryFields(data) {
    return post('users/mandatory-fields', data, true).then(response=>{
        return response;
    });
}
export function getCountries() {
    return post('get-countries', false).then(response=>response);
}